import { Image, Text, VStack } from '@chakra-ui/react'
import logo from 'assets/lottie/loader_wicar.gif'

import { SecondaryProps } from '../types'

export const SecondaryVariant: React.FC<SecondaryProps> = ({ title }) => {
  return (
    <VStack
      w={'full'}
      h={'full'}
      alignItems={'center'}
      justifyContent={'center'}>
      <Image
        w={'120px'}
        h={'120px'}
        alt={'loading_wicar'}
        src={logo}
      />
      {title && <Text>{title}</Text>}
    </VStack>
  )
}
